webpackJsonp([250],{

/***/ 1092:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawBatchDetail_vue__ = __webpack_require__(2687);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64ec7e62_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawBatchDetail_vue__ = __webpack_require__(4057);
function injectStyle (ssrContext) {
  __webpack_require__(4051)
  __webpack_require__(4053)
  this["$style"] = __webpack_require__(4055)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64ec7e62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WithdrawBatchDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64ec7e62_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WithdrawBatchDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 2687:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_table__ = __webpack_require__(1346);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__core_mixins_table__["b" /* default */]],
  data: function data() {
    return {
      id: this.$route.params.id,
      previousSelected: [],
      selected: [],
      search: {
        userid: this.$route.query.userid || null,
        status: this.$route.query.status * 1 || null
      },
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 200,
        total: 0
      },
      withdrawtype: '2,3',
      status_map: {
        '0': '入账',
        '1': '提现处理中',
        '2': '财务处理中',
        '3': '提现操作完成',
        '4': '提现操作被驳回',
        '5': '退回赏金',
        '80': '购物消费',
        '81': '消费退款',
        '82': '交易冲正',
        '99': '兑换'
        // map: [
        //   {key: 0, value: '入账'},
        //   {key: 1, value: '提现处理中'},
        //   {key: 2, value: '财务处理中'},
        //   {key: 3, value: '提现操作完成'},
        //   {key: 4, value: '提现操作被驳回'},
        //   {key: 5, value: '退回赏金'},
        //   {key: 80, value: '购物消费'},
        //   {key: 81, value: '消费退款'},
        //   {key: 82, value: '交易冲正'},
        //   {key: 99, value: '兑换'},
        // ],
      },
      tinyStatusMap: [{ key: 2, value: '财务处理中' }, { key: 3, value: '提现操作完成' }, { key: 4, value: '提现操作被驳回' }, { key: 5, value: '退回赏金' }]
    };
  },
  created: function created() {},

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     *
     */
    getTableData: function getTableData(params) {
      this.previousSelected = this.selected;
      this.$refs.table.clearSelection();
      params.id = this.id;
      return request.page('batchWithdrawBatchDetailByUser', params);
    },

    /**
     * 重载 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var _this = this;

      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
      this.$nextTick(function () {
        var selected = [];
        _this.table.forEach(function (row) {
          if (_this.previousSelected.includes(row.id)) {
            selected.push(row.id);
            _this.$refs.table.toggleRowSelection(row, true);
          }
        });
        _this.selected = selected;
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var selected = [];
      val.forEach(function (row) {
        selected.push(row.id);
      });
      this.selected = selected;
    },
    batchConfirm: function batchConfirm() {
      var _this2 = this;

      if (this.selected.length === 0) {
        this.$message.error('请先选择');
        return;
      }
      this.$confirm('是否批量确认已勾选内容？', '提示', { type: 'warning' }).then(function () {
        _this2.batchConfirmRequest();
      }).catch(function () {
        _this2.$message.info('已取消批量确认');
      });
    },
    batchConfirmRequest: function batchConfirmRequest() {
      var _this3 = this;

      if (this.search.status === 3) {
        // 欲确认已确认的单子
        this.$message.error('您无法确认已经确认的单子');
        return;
      }
      if (this.search.status === 4) {
        // 欲确认已回滚的单子
        this.$message.error('您无法确认已经回滚的单子');
        return;
      }
      var params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        id: this.id,
        uids: this.selected
      }, this.search);
      request.common('batchWithdrawBatchConfirm', params).then(function (data) {
        _this3.$message({
          showClose: true,
          message: '批量确认成功',
          type: 'success'
        });
        _this3.onRefresh();
      });
    },
    allConfirm: function allConfirm() {
      var _this4 = this;

      this.$confirm('是否一键确认全部内容？', '提示', { type: 'warning' }).then(function () {
        _this4.oneKeyConfirmRequest();
      });
    },
    onConfirm: function onConfirm(row) {
      var _this5 = this;

      if (!this.checkRowStatus(row)) {
        return;
      }
      this.$confirm('是否操作确认？', '提示', { type: 'warning' }).then(function () {
        _this5.confirmRequest(row);
      }).catch(function () {
        _this5.$message.info('已取消');
      });
    },
    onRollBack: function onRollBack(row) {
      var _this6 = this;

      if (!this.checkRowStatus(row, '回滚')) {
        return;
      }
      this.$prompt('请输入回滚原因', '提示', {
        inputPattern: /\S+/,
        inputErrorMessage: '请输入内容'
      }).then(function (_ref2) {
        var value = _ref2.value;

        _this6.rollbackRequest(row, value);
      }).catch(function () {
        _this6.$message.info('已取消');
      });
    },
    handleFailReason: function handleFailReason(row) {
      if (row.status * 1 !== 5) {
        return '';
      }
      return row.desc.replace(/赏金已退回\|/, '');
    },
    batchRollback: function batchRollback() {
      var _this7 = this;

      if (this.selected.length === 0) {
        this.$message.error('请先选择');
        return;
      }
      if (this.search.status === 3) {
        // 欲回滚已确认的单子
        this.$message.error('您无法回滚已经确认的单子');
        return;
      }
      if (this.search.status === 4) {
        // 欲回滚已回滚的单子
        this.$message.error('您无法回滚已经回滚的单子');
        return;
      }
      var params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        id: this.id,
        uids: this.selected
      }, this.search);
      request.common('batchWithdrawBatchRollback', params).then(function (data) {
        _this7.$message({
          showClose: true,
          message: '批量回滚成功',
          type: 'success'
        });
        _this7.onRefresh();
      });
    },
    checkRowStatus: function checkRowStatus(row) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '确认';

      if (row.status * 1 !== 2) {
        this.$message.error('您无法' + action + '此单子');
        return false;
      }
      return true;
    },
    confirmRequest: function confirmRequest(row) {
      var _this8 = this;

      var params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        id: this.id,
        uids: row.id
      }, this.search);
      request.common('batchWithdrawBatchConfirm', params).then(function (data) {
        _this8.$message({
          showClose: true,
          message: '确认成功',
          type: 'success'
        });
        _this8.onRefresh();
      });
    },
    rollbackRequest: function rollbackRequest(row, failReason) {
      var _this9 = this;

      var params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        id: this.id,
        uids: row.id,
        fail_reason: failReason
      }, this.search);
      request.common('batchWithdrawBatchRollback', params).then(function (data) {
        _this9.$message({
          showClose: true,
          message: '回滚成功',
          type: 'success'
        });
        _this9.onRefresh();
      });
    },
    oneKeyConfirmRequest: function oneKeyConfirmRequest() {
      var _this10 = this;

      var params = {
        id: this.id,
        status: 2,
        userid: this.search.userid,
        per_page: this.$route.query.per_page || this.pagination.per_page
      };
      request.loading('batchWithdrawBatchDetailByUser', params).then(function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref4) {
          var data = _ref4.data;
          var uidLists, postParams;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(data.data.length > 0)) {
                    _context.next = 10;
                    break;
                  }

                  uidLists = [];

                  data.data.forEach(function (item) {
                    uidLists.push(item.id);
                  });
                  postParams = {
                    id: _this10.id,
                    uids: uidLists,
                    status: 2,
                    userid: _this10.search.userid
                  };
                  _context.next = 6;
                  return request.loading('batchWithdrawBatchConfirm', postParams).then(function (data) {});

                case 6:
                  _context.next = 8;
                  return _this10.oneKeyConfirmRequest();

                case 8:
                  _context.next = 12;
                  break;

                case 10:
                  _this10.$message({
                    showClose: true,
                    message: '一键确认成功',
                    type: 'success'
                  });
                  _this10.onRefresh();

                case 12:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this10);
        }));

        return function (_x2) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
  }
});

/***/ }),

/***/ 4051:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4052);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2f407034", content, true, {});

/***/ }),

/***/ 4052:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"WithdrawBatchDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4053:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4054);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("3c0e9548", content, true, {});

/***/ }),

/***/ 4054:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"WithdrawBatchDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4055:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4056);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("57f928ac", content, true, {});

/***/ }),

/***/ 4056:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"WithdrawBatchDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4057:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("财务管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",staticClass:"layout-search-form medium",attrs:{"model":_vm.search,"label-width":"110px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch($event)}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"用户ID","prop":"userid"}},[_c('el-input',{attrs:{"placeholder":"请输入用户ID","clearable":""},model:{value:(_vm.search.userid),callback:function ($$v) {_vm.$set(_vm.search, "userid", $$v)},expression:"search.userid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"状态","prop":"status"}},[_c('el-select',{attrs:{"clearable":""},model:{value:(_vm.search.status),callback:function ($$v) {_vm.$set(_vm.search, "status", $$v)},expression:"search.status"}},_vm._l((_vm.tinyStatusMap),function(item){return _c('el-option',{key:item.key,attrs:{"label":item.value,"value":item.key}})}),1)],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索\n        ")])],1)],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":_vm.onRefresh}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15",staticStyle:{"display":"flex","justify-content":"space-between"}},[(_vm.$route.params.type !== '3')?_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.batchConfirm}},[_vm._v("批量确认\n      ")]):_vm._e(),_vm._v(" "),(_vm.$route.params.type !== '3')?_c('el-button',{attrs:{"type":"success","size":"small"},on:{"click":_vm.allConfirm}},[_vm._v("一键确认\n      ")]):_vm._e()],1),_vm._v(" "),_c('el-table',{ref:"table",attrs:{"data":_vm.table,"stripe":"","highlight-current-row":""},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"type":"selection","width":"55"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":"id"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"realname","label":"姓名"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"credit","label":"提现金额"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updatetime","label":"提现时间"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"状态"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.status_map[scope.row.status]))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fail_reason","label":"退回原因"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.handleFailReason(scope.row)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"button-gutter"},[_c('button-gutter',[(scope.row.status * 1 === 2 && _vm.$route.params.type !== '3')?_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":function($event){return _vm.onConfirm(scope.row)}}},[_vm._v("确定\n              ")]):_vm._e(),_vm._v(" "),(scope.row.status * 1 === 2 && _vm.$route.params.type !== '3')?_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.onRollBack(scope.row)}}},[_vm._v("回滚\n              ")]):_vm._e()],1)],1)]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/finance-withdraw-detail.4cbce20124d1544fe48e.js